<template>
  <section class="footer-cta" data-gtm-context="Footer">
    <div class="footer-cta__container">
      <hr>
      <div class="footer-cta__content">
        <h2 class="h1">
          {{title}}
        </h2>
        <router-link v-if="buttonLink" :to="{ name: buttonLink }" title="{{buttonText}}" class="btn btn--primary mt-10">{{buttonText}}</router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Join Transpond today"
    },
    buttonLink: {
      type: String,
      default: "Pricing"
    },
    buttonText: {
      type: String,
      default: "Get started"
    }
  },
}
</script>

<style scoped>
.footer-cta {
  margin-bottom: 3rem;
}

.footer-cta__container {
  max-width: 1288px;
  margin: 0 auto;
  padding: 0 24px;
}

.footer-cta__content {
  padding: 2rem 0;
}

@media (max-width: 768px) {
  .footer-cta__container {
    padding: 0 16px;
  }
}
</style>